import { ZIndex } from "@/styles/theme"
import { makeStyles } from "@/utils/makeStyles"

const useStyles = makeStyles(() => ({
	paper: {
		margin: "1rem",
		zIndex: ZIndex.modal,
		padding: "2.5rem",
		borderRadius: "0.5rem"
	}
}))

export default useStyles